import TextInput from 'components/forms/inputs/rhf-inputs/TextInput';
import { TaskFormState } from './useTaskForm';

/** Document management system: the DMS link. */
export const DmsFields = ({ form }: { form: TaskFormState }): JSX.Element => (
    <TextInput
        name="dmsData.dmsLink"
        control={form.methods.control}
        label="tasks.form.dms-link"
        placeholder="tasks.form.dms-link"
        validate={form.validUrl}
    />
);
